// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__z1PAg","total":"Cart_total__ynS2H","actions":"Cart_actions__zgxIM","button--alt":"Cart_button--alt__V5cI3","button":"Cart_button__g22tn"};